export default "__VITE_ASSET__CnOoGVsY__"